import { fetch } from "whatwg-fetch";
import Prompt from "./Jsons/Prompt.json";

// Requests go through same-origin Netlify Functions (netlify/functions/),
// which hold the backend API token server-side. Never call api.creataai.com
// directly with a token from client code.
const promptArray = Prompt.Promt

async function getImagesForPrompt(prompt) {
    let data = {
        username: "creataaicom",
        prompt: prompt
    }
    const res = await fetch(
        `/.netlify/functions/search-prompt`,
        {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data)
        }
    );
    if (!res.ok) {
        const errorText = await res.text().catch(() => res.statusText)
        throw new Error(`getImagesForPrompt failed (${res.status}): ${errorText}`)
    }
    let result = await res.json()
    return result
}

async function nsfwSignup(email) {
    let data = {
        username: "creataaicom",
        email: email
    }
    const res = await fetch(
        `/.netlify/functions/nsfw-signup`,
        {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data)
        }
    );
    if (!res.ok) {
        const errorText = await res.text().catch(() => res.statusText)
        throw new Error(`nsfwSignup failed (${res.status}): ${errorText}`)
    }
    let result = await res.json()
    return result
}

/**
 * Creates a Stripe Checkout Session for a credit top-up pack.
 * @param {{pack: string, username: string, email?: string, amount?: number}} params
 *   amount (dollars) is required when pack is 'custom', ignored otherwise.
 * @returns {Promise<{success: boolean, url: string}>}
 */
async function createTopupSession({ pack, username, email, amount }) {
    const res = await fetch(
        `/.netlify/functions/create-topup-session`,
        {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ pack, username, email, amount })
        }
    );
    const result = await res.json().catch(() => ({}))
    if (!res.ok || !result.success) {
        throw new Error(result.error || `createTopupSession failed (${res.status})`)
    }
    return result
}

/**
 * Confirms a completed credit top-up Checkout Session and credits the
 * ledger. Idempotent server-side - safe to call more than once for the
 * same session_id.
 * @param {string} sessionId
 * @returns {Promise<{success: boolean, purchasedBalance?: number, reason?: string}>}
 */
async function confirmTopup(sessionId) {
    const res = await fetch(
        `/.netlify/functions/confirm-topup`,
        {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ session_id: sessionId })
        }
    );
    const result = await res.json().catch(() => ({}))
    return result
}

function getRandomIndex(N) {
    return Math.floor(Math.random() * N);
}

/**
 *
 * @param {*} n number of indices
 * @param {*} N max value of index
 * @returns array of indices for prompts
 */
function getRandomIndices(n,N) {
    var prompts = []
    var imageArray = []
    for (var i = 0; i < n; i++) {
        prompts.push(getRandomIndex(N))
    }
    return prompts
}

/**
 * Not working
 * @returns
 */
async function getRandomImages() {
    // select 10 prompt randomly and get 3 images from each prompt
    //let currentIndex = Prompt.length;
    //let promptArray = Prompt.Prompt
    let N = promptArray.length //Prompt.Promt.length


    var prompts = []
    var imageArray = []
    for (var i = 0; i < 10; i++) {
        prompts.push(getRandomIndex(N))
    }
    console.log(prompts)
    console.log(`0: ${prompts[0]}`)

    for (var i = 0; i < 1; i++) {
        var j = prompts[i]
        var promptStr = promptArray[j]
        //var images = await getImagesForPrompt(promptStr)
        getImagesForPrompt(promptStr).then((images) => {
            console.log(images)
            console.log(images[0])
            var n = images.length
            console.log(`${n}`)
            j = getRandomIndex(50)
            console.log(`${j}`)
            imageArray.push(images[j])
            j = getRandomIndex(50)
            console.log(`${j}`)
            imageArray.push(images[j])
        })
    }
    console.log(imageArray)
    return imageArray
}

export default {
    getImagesForPrompt,
    getRandomImages,
    getRandomIndices,
    nsfwSignup,
    createTopupSession,
    confirmTopup
}
